import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/fotos')({
  component: lazyRouteComponent(
    () => import('@/features/fotos/components/fotos-page'),
    'FotosPage'
  ),
})
